/**
 * Quick Actions widget — shortcuts to common tasks.
 *
 * Cross-References:
 *   - FR-DASH-002: Default widgets
 *   - dashboard screen spec: Quick Links widget
 */
import { useNavigate } from 'react-router-dom';
import { Users, Shield, Settings, FileText } from 'lucide-react';
import { useAuthStore } from '@/stores/authStore';
import type { WidgetProps } from '@/types';

interface QuickAction {
  label: string;
  path: string;
  icon: React.ComponentType<{ size?: number }>;
  permission?: string;
}

const ACTIONS: QuickAction[] = [
  { label: 'User Directory', path: '/directory', icon: Users },
  { label: 'Manage Users', path: '/admin/users', icon: Shield, permission: 'users.manage.org' },
  { label: 'Audit Logs', path: '/admin/audit', icon: FileText, permission: 'audit.read.org' },
  { label: 'Tenant Settings', path: '/admin/settings', icon: Settings, permission: 'tenants.manage.org' },
];

export function QuickActionsWidget(_props: WidgetProps) {
  const navigate = useNavigate();
  const permissions = useAuthStore((s) => s.user?.permissions ?? []);

  const visible = ACTIONS.filter(
    (a) => !a.permission || permissions.includes(a.permission),
  );

  return (
    <div className="quick-actions">
      {visible.map((action) => (
        <button
          key={action.path}
          className="quick-actions__item"
          onClick={() => navigate(action.path)}
        >
          <action.icon size={18} />
          <span>{action.label}</span>
        </button>
      ))}
      {visible.length === 0 && (
        <p className="quick-actions__empty">No quick actions available.</p>
      )}
    </div>
  );
}
